import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ChangeEvent, useState } from 'react';
import { PasswordInputProps } from '../../Interfaces/Props';

const PasswordComp: React.FC<PasswordInputProps> = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(e);
  };

  const handleCopyPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
  };

  return (
    <div className="relative">
      <input
        type={showPassword ? 'text' : 'password'}
        name={props.name}
        value={props.value}
        onBlur={props.onBlur}
        onChange={handleChange}
        className={props.className}
        placeholder={props.placeholder}
        onCopy={handleCopyPaste}
        onCut={handleCopyPaste}
      />
      <div className="absolute right-0 top-0 mt-2 mr-3" title="Show Password">
        <FontAwesomeIcon
          icon={showPassword ? faEye : faEyeSlash}
          onClick={toggleShowPassword}
          className="cursor-pointer"
        />
      </div>
    </div>
  );
};

export default PasswordComp;
